import * as yup from 'yup';
import type { Schema } from 'yup';
import { IRegressionModel } from 'generated/graphql';

export const schema: Schema = yup.object({
  factors: yup.array().of(yup.mixed().required()).required().min(1),
  lookbackWindowSize: yup.number().required().min(1),
  regressionModel: yup.mixed().required().oneOf(Object.values(IRegressionModel)),
});
